export default __webpack_public_path__ + "static/media/web-crowd.6d61f6f6.svg";